'use strict';
var shadedtool = {
	init: function () {
		if (screen.width < 768) {
			$(function () {
				$('#shaded-tool-carousel').slick({
					dots: false,
					infinite: false,
					speed: 300,
					slidesToShow: 3,
					slidesToScroll: 3,
					responsive: [{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
					]
				});
			});
		}
	}
};

if (screen.width < 768) {
	$(function () {
		$('#ultimate-beauty').slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
			]
		});
	});

}

$(function () {
	$("#tabs").tabs();
});


$('.skincare-tab').click(function () {
	if (this.id == 'scin-tab1') {
		$('.ultimate-beauty-regimen-skin-concern-day').show();
		$('.ultimate-beauty-regimen-skin-concern-night').hide();
	} else {
		$('.ultimate-beauty-regimen-skin-concern-day').hide();
		$('.ultimate-beauty-regimen-skin-concern-night').show();
	}
})

function update() {
	var $lis = $('.skincare-produtssets > li'),
		$checked = $('input:checked.regimen-checkbox'),
		limit = 2,
		$notchecked = $('input:not(:checked).regimen-checkbox');
	var disableuncheckedbox = false;
	$lis.hide().removeClass("checked-product-filter");
	$(".skin-choose-desc").removeClass("skin-choose-desc-selected");
	$(".regimen-filter-heading-checked").removeClass("regimen-day-night-checked");
	$(".reginmen-product-setlist").removeClass("reginmen-product-setlist-proddisplay");
	if ($checked.length) {
		$(".regimen-filter-heading-checked").addClass("regimen-day-night-checked");
		$(".reginmen-product-setlist").addClass("reginmen-product-setlist-proddisplay");
		if ($checked.length >= 2) {
			disableuncheckedbox = true;
		}
		var selector = $checked.map(function () {
			$lis.filter('.' + $(this).attr('rel')).show().addClass("checked-product-filter");
			$(this).parent().parent().find(".icon-heading").addClass("icon-heading-selected");
			var img = $(this).parent().find("img");
			var checkeddatasrc = img.attr('data-src-checked');
			img.attr("src", checkeddatasrc);
			return '.' + $(this).attr('rel');
		}).get().join('');

	} else {
		$lis.show();
	}
	if ($notchecked.length) {
		var selector = $notchecked.map(function () {
			if (disableuncheckedbox) {
				$(this).attr("disabled", true);
			} else {
				$(this).attr("disabled", false);
			}
			$(this).parent().parent().find(".icon-heading").removeClass("icon-heading-selected");
			var img = $(this).parent().find("img");
			var uncheckeddatasrc = img.attr('data-src-uncheked');
			img.attr("src", uncheckeddatasrc);
			return '.' + $(this).attr('rel');
		}).get().join('');
	} else {

	}
}
if ($(".regimen-skin-concern")[0]) {
	$('.regimen-skin-icons img').on('click', function () {
		$(".skin-choose-desc").addClass("skin-choose-desc-selected");
	});
	$('div.tags').delegate('input[type=checkbox].regimen-checkbox', 'click', update);
	update();
}


export default shadedtool;